/** Configuration partagée vue-tel-input — Sénégal (+221) par défaut, sans géolocalisation navigateur. */
export const TEL_INPUT_DEFAULT_COUNTRY = 'SN' as const
export const TEL_INPUT_DEFAULT_DIAL_CODE = 221

export const telInputDropdownOptions = {
	showDialCodeInList: true,
	showDialCodeInSelection: true,
	showFlags: true,
	showSearchBox: true,
}

/** Props à passer sur chaque <vue-tel-input> (évite +351 / détection IP). */
export const telInputProps = {
	defaultCountry: TEL_INPUT_DEFAULT_COUNTRY,
	autoDefaultCountry: false,
	mode: 'international' as const,
	preferredCountries: ['SN', 'FR', 'CI', 'ML', 'GN', 'MR'],
}
